module.exports = __webpack_public_path__ + "static/media/group-195-copy.aa463d42.svg";